<div class="side-nav" id="favouritesContainer">
    <span class="favourite-title">{{dataService.res('Dt-Favorites-Favorites')}}</span> <a id='closeFavoritebtn'
        class="close-btn" (click)="closeFavorites()">&times;</a>
    <div style="overflow: auto; height: 100%">
        <favorites [ObjectTypeNames]="ObjectTypeNames" (onItemClicked)="itemClicked($event)"></favorites>
    </div>
</div>